export function getContentContainer(): HTMLElement | null {
	return document.querySelector(".landing-page-content-container");
}

export function getPreviewTableContainer(): HTMLElement | null {
	return document.querySelector(".sample-preview-table-container");
}
